import React, { Component } from 'react';
//import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
//import Card from 'react-bootstrap/Card';
//import Nav from 'react-bootstrap/Nav';
import {
    Table,
    Text,
    keys,
    Group,
    UnstyledButton,
    rem,
    Center,
    Divider,
    Flex,
    Collapse,
    Timeline,
    Space,
    Loader,
    Select,
    Paper
} from '@mantine/core';
import dayjs from 'dayjs';

import classes from '../TableSort.module.css';
import { IconSelector, IconChevronDown, IconChevronUp, IconLineDashed } from '@tabler/icons-react';
import HardwareTicketDataService from '../../services/hardware-ticket-activities';
import HoldingTableDataService from '../../services/holding-table-activities';

import AssignTechsTicketsCalendarService from '../../services/assign-techs_tickets-calendar-activities';

import { REPORT_TENANT_CHANGE_RESOLVED } from '../../features/actions/Is-Logged-Actions';
import { 
    REPORT_TIIMESPAN_CHANGE_RESOLVED, 
    REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED, 
    REPORT_ASSIGNED_TO_CHANGE_RESOLVED, 
    UPDATE_TIMESPAN_TICKET_REPORT_OPEN_STATUS,
    UPDATE_TIMESPAN_SORTING
} from '../../features/actions/Reports-Actions';

import { DatePickerInput } from '@mantine/dates';
import { store } from '../../app/store';


// const chartData = {
//     labels: ['January', 'February', 'March',
//              'April', 'May'],
//     datasets: [
//       {
//         label: 'Rainfall',
//         backgroundColor: [
//           '#B21F00',
//           '#C9DE00',
//           '#2FDE00',
//           '#00A6B4',
//           '#6800B4'
//         ],
//         hoverBackgroundColor: [
//         '#501800',
//         '#4B5000',
//         '#175000',
//         '#003350',
//         '#35014F'
//         ],
//         data: [65, 59, 80, 81, 56]
//       }
//     ]
//   }

//import { LOGOUT } from '../features/actions/Is-Logged-Actions';

function filterData(data, search) {
    const query = search.toLowerCase().trim();
    return data.filter((item) =>
        keys(data[0]).some((key) => item[key].toLowerCase().includes(query))
    );
}

function sortData(
    data,
    payload
) {
    const { sortBy } = payload;

    if (!sortBy) {
        return filterData(data, payload.search);
    }

    return filterData(
        [...data].sort((a, b) => {
            if (payload.reversed) {
                return b[sortBy].localeCompare(a[sortBy]);
            }

            return a[sortBy].localeCompare(b[sortBy]);
        }),
        payload.search
    );
}

function updateTimespan(timespan) {
    return {
        type: 'UPDATE_TIMESPAN',
        payload: timespan
    }
}

function updateTimespanType(type) {
    return {
        type: 'UPDATE_TIMESPAN_TYPE',
        payload: type
    }
}

function updateTimespanAssignedTo(assignedTo) {
    return {
        type: 'UPDATE_TIMESPAN_ASSIGNEDTO',
        payload: assignedTo
    }
}

function handleTimespanChange(timespan) {
    let state = store.getState();

    // If they changed to a different person than what is currently selected, do all this stuff, otherwise do nothing
    if (timespan !== state.reports.timespan) {

        //store.dispatch(resetDepartment());  // remove the old data so we free up space in the front end data store
        store.dispatch(updateTimespan(timespan));
    }
    console.log(timespan);
}

function handleTimespanTypeChange(type) {
    let state = store.getState();

    // If they changed to a different person than what is currently selected, do all this stuff, otherwise do nothing
    if (type !== state.reports.timespanType) {

        //store.dispatch(resetDepartment());  // remove the old data so we free up space in the front end data store
        store.dispatch(updateTimespanType(type));
    }
    console.log(type);
}

function handleTimespanAssignedToChange(assignedTo) {
    let state = store.getState();

    // If they changed to a different person than what is currently selected, do all this stuff, otherwise do nothing
    if (assignedTo !== state.reports.timespanAssignedTo) {

        //store.dispatch(resetDepartment());  // remove the old data so we free up space in the front end data store
        store.dispatch(updateTimespanAssignedTo(assignedTo));
    }
    console.log(assignedTo);
}

function Th(props) {
    const Icon = props.sorted ? (props.reversed ? IconChevronUp : IconChevronDown) : IconSelector;
    return (
        <Table.Th className={classes.th}>
            <UnstyledButton onClick={props.onSort} className={classes.timespanReportControl}>
                <Group justify="left"/* justify="space-between" */>
                    <Text fw={800} fz="sm">
                        {props.children}
                    </Text>
                    <Center className={classes.icon}>
                        <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                    </Center>
                </Group>
            </UnstyledButton>
        </Table.Th>
    );
}

class TimespanTickets extends Component {


    constructor(props) {
        super(props);
        let state = store.getState();

        this.getTimespanTickets = this.getTimespanTickets.bind(this);
        this.goToHardwareTicketDetails = this.goToHardwareTicketDetails.bind(this);
        this.goToHoldingTicketDetails = this.goToHoldingTicketDetails.bind(this);

        var timespan = [state.reports.timespan[0] ? dayjs(Date.parse(state.reports.timespan[0])).$d : null, state.reports.timespan[1] ? dayjs(Date.parse(state.reports.timespan[1])).$d : null]

        this.state = {
            timespanTickets: [],
            itemCount: 0,
            timespan: timespan,
            timespanType: state.reports.timespanType,
            timespanAssignedTo: state.reports.timespanAssignedTo,
            techList: [],
            showLoader: false,
            sortBy: "id",
            sortOrder: "ASC"
        };

    }

    setSorting(field) {
        const reversed = field === this.state.sortBy ? !this.state.reverseSortDirection : false;
        const search = this.state.search;
        this.setState({
            reverseSortDirection: reversed,
            sortBy: field,
            sortedData: sortData(this.state.data, { sortBy: field, reversed, search })
        });
    };

    componentDidMount() {
        //this.getTimespanTickets();

        this.setState({
            sortBy: this.props.reportInfo.timespan_sort_by,
            sortOrder: this.props.reportInfo.timespan_sort_order
        }, () => {
            this.getTimespanTickets();
        });

        // AssignTechsTicketsCalendarService.getTechsForMyTicketsTableDropdown(this.props.loggedStatus.id)
        //     .then(response => {
        //         console.log("Response from backend for tech list was: ");
        //         console.log(response);

        //         let updatedTechList = []

        //         response.data.results.map((tech) => {
        //             updatedTechList.push(tech);
        //             return updatedTechList;   // included to appease compile warning. not actually needed
        //         });
        //         this.setState({ techList: [{id: 0, primary_tenant_id: 0, tech_full_name: "All"}, {id: -1, primary_tenant_id: 0, tech_full_name: "Unassigned"}, ...updatedTechList] });

        //     })
        //     .catch(e => {
        //         console.log(e);
        //         console.log("You're in the CATCH clause of the assigned tech selector component. The line printed above should be the error text");
        //         console.log("Should hopefully contain the status code of the failed attempt: ", e.response.status);

        //         if (e.response.status === 401) {   // the token was stale, so try again after the state updates with the new token
        //             console.log("The assigned tech selector is asking the API again since the token was stale");
        //         }
        //     });
    }

    getHistory(id, timezone_adjustment_factor, source) {
        if (this.state[`collapse${id}`]) {
            this.setState({
                [`collapse${id}`]: false
            });
        } else {
            if(source === "Hardware") {
                HardwareTicketDataService.getTicketHistory(id, timezone_adjustment_factor)
                .then(response => {
                    console.log("Response from history endpoint was: ", response);
                    this.setState({
                        [`history${id}`]: response.data.results,
                        [`loading${id}`]: true
                    }, () => {
                        this.setState({
                            [`collapse${id}`]: true,
                            [`loading${id}`]: false
                        })
                    });
                })
                .catch(e => {
                    console.log(e);
                });
            }

            else {
                HoldingTableDataService.getTicketHistory(id, timezone_adjustment_factor)
                .then(response => {
                    console.log("Response from history endpoint was: ", response);
                    this.setState({
                        [`history${id}`]: response.data.results,
                        [`loading${id}`]: true
                    }, () => {
                        this.setState({
                            [`collapse${id}`]: true,
                            [`loading${id}`]: false
                        })
                    });
                })
                .catch(e => {
                    console.log(e);
                });
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.loggedStatus.report_tenant_change_detected && !prevProps.loggedStatus.report_tenant_change_detected) {
            this.props.REPORT_TENANT_CHANGE_RESOLVED();
            this.setState({
                timespanTickets: []
            });
   
            // get the new list of timespan tickets
            this.getTimespanTickets();
        }

        if(this.props.reportInfo.report_timespan_change_detected || this.props.reportInfo.report_timespan_type_change_detected || this.props.reportInfo.report_assigned_to_change_detected) {
            if(this.props.reportInfo.report_timespan_change_detected && !prevProps.reportInfo.report_timespan_change_detected) {
                this.props.REPORT_TIIMESPAN_CHANGE_RESOLVED();
                console.log("timespan change detected in child");
                this.setState({
                    timespanTickets: []
                });

                this.getTimespanTickets();
            }

            else if(this.props.reportInfo.report_timespan_type_change_detected && !prevProps.reportInfo.report_timespan_type_change_detected) {
                this.props.REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED();
                console.log("timespan type change detected in child");

                this.setState({
                    timespanTickets: []
                });

                this.getTimespanTickets();
            }

            else if(this.props.reportInfo.report_assigned_to_change_detected && !prevProps.reportInfo.report_assigned_to_change_detected) {
                this.props.REPORT_ASSIGNED_TO_CHANGE_RESOLVED();
                console.log("timespan assigned to change detected in child");

                this.setState({
                    timespanTickets: []
                });

                this.getTimespanTickets();
            }
        }
    }


    // use the global state value for the selected tenant from the report component to get the necessary overdue ticket info
    getTimespanTickets() {
        this.setState({
            showLoader: true
        });

        if(this.props.reportInfo.timespan && this.props.reportInfo.timespanAssignedToArray && this.props.reportInfo.timespan.length > 1) {
            var timespan = [this.props.reportInfo.timespan[0] ? dayjs(Date.parse(this.props.reportInfo.timespan[0])).$d : null, this.props.reportInfo.timespan[1] ? dayjs(Date.parse(this.props.reportInfo.timespan[1])).$d : null]

            // generate the list of id numbers user has requested in the filter drop down
            let requesterIdList = [];

            for(let r = 0; r < this.props.reportInfo.timespanAssignedToArray.length; r++) {
                requesterIdList.push(this.props.reportInfo.timespanAssignedToArray[r].value);
            }

            console.log("List of ids to send: ", requesterIdList);

            HardwareTicketDataService.getTimespanTickets(this.props.loggedStatus.report_tenant_id_selected, timespan, this.props.reportInfo.timespanType, requesterIdList, this.props.loggedStatus.id, this.props.loggedStatus.timezone_adjustment_factor)
            .then(response => {
                console.log("Timespan ticket list returned: ", response);
                this.setState({
                    timespanTickets: response.data.results,
                    itemCount: response.data.rowCount,
                    showLoader: false
                }, () => this.sortTable(this.state.timespanTickets, this.state.sortBy, this.state.sortOrder));
            })
            .catch(e => {
                console.log(e);
            });
        }
    }

    goToHardwareTicketDetails(id) {
        this.props.history.push(`/hardwareTickets/${id}`);
    }

    goToHoldingTicketDetails(id) {
        this.props.history.push(`/clarifyTicket/${id}`);
    }

    handleReportOpenChange() {
        this.props.UPDATE_TIMESPAN_TICKET_REPORT_OPEN_STATUS();     // toggles global state value between true and false
    }

    // locally sorts the data displayed in the table based on the column clicked and sort order
    // affects timespanTickets []
    sortTable(array, sortBy, sortOrder) {
        const sortedArray = [...array].sort((a, b) => {
            let aVal = a[sortBy];
            let bVal = b[sortBy];
        
            // Treat null or undefined assigned_tech_name as "Unassigned"
            if (sortBy === "assigned_tech_name") {
              aVal = aVal ?? "Unassigned";
              bVal = bVal ?? "Unassigned";
            }
        
            // For string comparison (case-insensitive)
            if (typeof aVal === "string" && typeof bVal === "string") {
              const result = aVal.toLowerCase().localeCompare(bVal.toLowerCase());
              return sortOrder === "ASC" ? result : -result;
            }
        
            // For number or date comparison
            if (aVal > bVal) return sortOrder === "ASC" ? 1 : -1;
            if (aVal < bVal) return sortOrder === "ASC" ? -1 : 1;
            return 0;
        });

        console.log("here is the sorted array: ", sortedArray);
        
        //return sortedArray;
        this.setState({
            timespanTickets: sortedArray
        });
    }

    // fired when user clicks a table header - sorts timespan tickets by column and flips sort order
    handleSortByAndOrderChange(new_column_name) {

        let newSortOrder;
        if(this.state.sortOrder === "ASC") {
            newSortOrder = "DESC";
        }

        else {
            newSortOrder = "ASC";
        }

        // if this is a new column, change both the column sorted and the order
        if(new_column_name !== this.state.sortBy) {
            this.setState({
                sortBy: new_column_name,
                sortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortTable(this.state.timespanTickets, new_column_name, newSortOrder));
        }

        // otherwise it was the same column, so just change the sort order
        else {
            this.setState({
                sortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortTable(this.state.timespanTickets, this.state.sortBy, newSortOrder));
        }

        // update global state for sortBy and sortOrder here
        this.props.UPDATE_TIMESPAN_SORTING({sortBy: new_column_name});
    }


    render() {
        const rows = this.state.timespanTickets.map((ticket) => {
            //if (ticket.source === "Hardware") {
                return <>
                            <Table.Tr key={`${ticket.source}_${ticket.id}`} onClick={(event) => { event.stopPropagation(); this.getHistory(ticket.id, this.props.loggedStatus.timezone_adjustment_factor, ticket.source)}}>
                                {this.state[`loading${ticket.id}`] ?
                                    <>
                                        <Table.Td w="14%"><Loader /></Table.Td>
                                    </>
                                    : <>
                                        {ticket.source === "Hardware" ? 
                                            <Table.Td w="13%">{`# ${ticket.id}`}</Table.Td>
                                            :
                                            <Table.Td w="13%">{`Temp# ${ticket.id}`}</Table.Td>
                                        }
                                        <Table.Td w="11%">{ticket.sla_name ? ticket.sla_name : "Not Yet Set"}</Table.Td>
                                        <Table.Td w="8%">{ticket.resolution_status}</Table.Td>
                                        <Table.Td w="15%">{ticket.asker_name}</Table.Td>
                                        <Table.Td w="15%">{ticket.assigned_tech_name ? ticket.assigned_tech_name : "Unassigned"}</Table.Td>
                                        <Table.Td w="14%">{ticket.formatted_date_time_created}</Table.Td>
                                        <Table.Td w="14%">{ticket.ticket_title}</Table.Td>
                                    </>}
                            </Table.Tr>
                            {this.state[`history${ticket.id}`] ?
                                // <Table>
                                    // <Table.Tbody>
                                        <Table.Tr
                                            style={{
                                                border: this.state[`collapse${ticket.id}`] ? undefined : 'none',
                                                height: this.state[`collapse${ticket.id}`] ? 'auto' : 0,
                                                overflow: 'hidden',
                                                transition: 'height 300ms ease',
                                            }}
                                        >
                                            <Table.Td 
                                                w="100%" 
                                                /* py="0" */ py={this.state[`collapse${ticket.id}`] ? 'md' : 0} 
                                                px="xl" 
                                                colSpan={7}
                                                style={{
                                                    border: 'none',
                                                    padding: this.state[`collapse${ticket.id}`] ? undefined : 0,
                                                }}
                                            >
                                                <Collapse in={this.state[`collapse${ticket.id}`]}>
                                                    <Timeline active={this.state[`history${ticket.id}`].length} bulletSize={24} lineWidth={2} my="lg">
                                                        {this.state[`history${ticket.id}`].map((event, index) => (
                                                            <Timeline.Item>
                                                                <div>{event.formatted_date_time_created}<IconLineDashed color="#00abfb" />{event.description} by {`${event.creator_first_name} ${event.creator_last_name}`}</div>
                                                            </Timeline.Item>
                                                        ))}
                                                    </Timeline>
                                                </Collapse>
                                            </Table.Td>
                                        </Table.Tr> : <></>}
                                    
                                
                </>
            //}

            // else {
            //     return <>
            //         <Divider />
            //         <Table highlightOnHover="true" style={{ cursor: "pointer" }}>
            //             <Table.Tbody>
            //                 <Table.Tr key={`unclarified_${ticket.id}`} onClick={() => this.getHistory(ticket.id, this.props.loggedStatus.timezone_adjustment_factor, ticket.source)}>
            //                     <Table.Td w="14%">{`Temp# ${ticket.id}`}</Table.Td>
            //                     <Table.Td w="14%">{ticket.sla_name ? ticket.sla_name : "Not Yet Set"}</Table.Td>
            //                     <Table.Td w="16%">{ticket.asker_name}</Table.Td>
            //                     <Table.Td w="16%">{ticket.assigned_tech_name ? ticket.assigned_tech_name : "Unassigned"}</Table.Td>
            //                     <Table.Td w="15%">{ticket.formatted_date_time_created}</Table.Td>
            //                     <Table.Td w="15%">{ticket.ticket_title ? ticket.ticket_title : "TBD"}</Table.Td>
            //                 </Table.Tr>
            //             </Table.Tbody>
            //         </Table>
            //     </>
            // }
        })


        return (
            <>
                {/* <Flex
                    gap="lg"
                >
                    <DatePickerInput
                        placeholder="Pick date"
                        w="300px"
                        type="range"
                        value={this.state.timespan}
                        onChange={(e) => {
                            handleTimespanChange(e);
                            this.setState({ timespan: e }, () => this.getTimespanTickets())
                        }}
                        allowDeselect={false}
                    />
                    <Select
                        placeholder="Pick type"
                        value={this.state.timespanType}
                        onChange={(e) => {
                            handleTimespanTypeChange(e);
                            this.setState({ timespanType: e }, () => this.getTimespanTickets())
                        }}
                        data={['All', 'Open', 'Resolved']}
                        allowDeselect={false}
                    />
                    <Select
                        placeholder="Assigned to"
                        value={
                            this.state.techList && this.state.techList.length > 0 && this.state.techList.find(v => v.id === this.state.timespanAssignedTo) &&
                            this.state.techList.find(v => v.id === this.state.timespanAssignedTo).tech_full_name
                        }
                        data={this.state.techList.map((tech) => (tech.tech_full_name))}
                        onChange={(e) => {
                            let newAssignedToId = this.state.techList.find(t => t.tech_full_name === e).id;
                            handleTimespanAssignedToChange(newAssignedToId);
                            this.setState({ timespanAssignedTo: newAssignedToId }, () => this.getTimespanTickets())
                        }}
                        allowDeselect={false}
                    />
                </Flex>
                <Space m="md" /> */}
                <Paper withBorder p="md" radius="md" display="block" m="5px" onClick={() => this.handleReportOpenChange()}>
                    {this.state.showLoader === true ?
                        <div><Text size="xl" fw={700} component="span">{`Created Tickets ( `}</Text><span style={{ display: 'inline-flex', alignItems: 'center' }}><Loader type="dots"/></span><Text size="xl" fw={700} component="span">{` )`}</Text>{this.props.reportInfo.timespan_ticket_report_open ? <IconChevronDown style={{marginLeft: "10px"}}/> : <IconChevronUp style={{marginLeft: "10px"}}/>}</div>
                        :
                        <div><Text size="xl" fw={700} component="span">{`Created Tickets ( `}</Text><Text size="xl" fw={700} component="span" c="blue">{`${this.state.itemCount}`}</Text><Text size="xl" fw={700} component="span">{` )`}</Text>{this.props.reportInfo.timespan_ticket_report_open ? <IconChevronDown style={{marginLeft: "10px"}}/> : <IconChevronUp style={{marginLeft: "10px"}}/>}</div>
                    }
                    <Collapse in={this.props.reportInfo.timespan_ticket_report_open}>
                        <Table highlightOnHover="true" style={{ cursor: "pointer" }}>
                            <Table.Thead>
                                <Table.Tr>
                                    <Th 
                                        w="13%"
                                        sorted={this.state.sortBy === 'id'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("id")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "id" ? "activeMyAssignedTicketsHeader" : ""}>ID</div>
                                    </Th>
                                    <Th 
                                        w="11%"
                                        sorted={this.state.sortBy === 'sla_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("sla_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "sla_name" ? "activeMyAssignedTicketsHeader" : ""}>Priority</div>
                                    </Th>
                                    <Th 
                                        w="8%"
                                        sorted={this.state.sortBy === 'resolution_status'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("resolution_status")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "resolution_status" ? "activeMyAssignedTicketsHeader" : ""}>Status</div>
                                    </Th>
                                    <Th 
                                        w="15%"
                                        sorted={this.state.sortBy === 'asker_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("asker_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "asker_name" ? "activeMyAssignedTicketsHeader" : ""}>Requester</div>
                                    </Th>
                                    <Th 
                                        w="15%"
                                        sorted={this.state.sortBy === 'assigned_tech_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("assigned_tech_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "assigned_tech_name" ? "activeMyAssignedTicketsHeader" : ""}>Assigned To</div>
                                    </Th>
                                    <Th 
                                        w="14%"
                                        sorted={this.state.sortBy === 'formatted_date_time_created'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("formatted_date_time_created")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "formatted_date_time_created" ? "activeMyAssignedTicketsHeader" : ""}>Time Created</div>
                                    </Th>
                                    <Th 
                                        w="14%"
                                        sorted={this.state.sortBy === 'ticket_title'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("ticket_title")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "ticket_title" ? "activeMyAssignedTicketsHeader" : ""}>Title</div>
                                    </Th>
                                </Table.Tr>
                            </Table.Thead>
                        {/* </Table> */}
                        {this.props.reportInfo.timespan_ticket_report_open ?
                            <Table.Tbody>
                                
                            {rows && rows.length > 0 ? (
                                rows
                            ) : (
                                // <Table highlightOnHover="true" style={{ cursor: "pointer" }}>
                                    // <Table.Tbody>
                                        <Table.Tr>
                                            <Table.Td>
                                                <Text fw={500} ta="center">
                                                    Nothing found
                                                </Text>
                                            </Table.Td>
                                        </Table.Tr>
                                    // </Table.Tbody>
                                // </Table>
                            )}
                            </Table.Tbody>
                            :
                            undefined
                        }
                        </Table>
                            
                    </Collapse>
                </Paper>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,    // Use global state to control which link is highlighted
        reportInfo: state.reports
    };
}

export default connect(mapStateToProps, { REPORT_TENANT_CHANGE_RESOLVED, REPORT_TIIMESPAN_CHANGE_RESOLVED, REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED, REPORT_ASSIGNED_TO_CHANGE_RESOLVED, UPDATE_TIMESPAN_TICKET_REPORT_OPEN_STATUS, UPDATE_TIMESPAN_SORTING })(TimespanTickets);